import type { DpEvent } from '@/core/events/DpEvent';

export class RealTimeConnectionRestored implements DpEvent {
  static readonly eventName = 'RealTimeCommunication:Restored';

  readonly name = RealTimeConnectionRestored.eventName;
}
